/** User-facing message when API blocks delete due to Active/Paid admission. */
export function messageFromCustomerDeleteError(data) {
  if (!data || typeof data !== "object") {
    return "Cannot delete customer.";
  }

  const blocked =
    data.blockedAdmissions ||
    (Array.isArray(data.blocked) && data.blocked[0]?.blockedAdmissions) ||
    [];

  if (blocked.length > 0) {
    const names = blocked
      .map((a) => `"${a.name || a.admission_id}"`)
      .slice(0, 3)
      .join(", ");
    const more = blocked.length > 3 ? ` and ${blocked.length - 3} more` : "";
    return `Cannot delete: linked admission${blocked.length > 1 ? "s" : ""} ${names}${more} ${blocked.length > 1 ? "are" : "is"} Active or Paid.`;
  }

  return data.error || data.message || "Cannot delete customer.";
}

export function isAdmissionBlockedDeleteResponse(status, data) {
  return (
    status === 409 ||
    data?.code === "ADMISSION_ACTIVE_OR_PAID"
  );
}
